import React, { forwardRef } from 'react';
import classNames from 'classnames';

import { getInputClassName, InputClassProps } from '../input-class-name.util';

type ListboxButtonProps = {
  truncate?: boolean;
  showSelectedItemsBadge?: boolean;
  selectedItemsCount?: number;
  isPlaceholder?: boolean;
  className?: string;
  children?: React.ReactNode;
} & InputClassProps;

export const ListboxButton = forwardRef<HTMLButtonElement, ListboxButtonProps>(
  (
    {
      disabled,
      hasError,
      fullWidth,
      truncate,
      variant,
      height,
      showSelectedItemsBadge,
      selectedItemsCount,
      isPlaceholder,
      className,
      children,
      ...rest
    },
    ref
  ) => (
    <button
      ref={ref}
      type="button"
      disabled={disabled}
      className={classNames(
        'relative inline-flex items-center',
        'bg-select bg-no-repeat bg-right-4 pr-14',
        'text-left cursor-default',
        getInputClassName({
          variant,
          disabled,
          hasError,
          fullWidth,
          height,
          isPlaceholder,
        }),
        {
          truncate,
          'bg-right-4 pr-8': height === 'md',
          'bg-right-2 pr-8': height === 'sm',
        },
        className
      )}
      {...rest}
    >
      {children}
      {showSelectedItemsBadge &&
      selectedItemsCount &&
      selectedItemsCount > 0 ? (
        <span className="ml-2 w-5 h-5 rounded-full bg-teal-500 text-white text-xs flex items-center justify-center">
          {selectedItemsCount}
        </span>
      ) : null}
    </button>
  )
);
